import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';

// ----------------------------------------------------------------------

function objFromArray(array, key = 'id') {
  return array.reduce((accumulator, current) => {
    accumulator[current[key]] = current;
    return accumulator;
  }, {});
}

const initialState = {
  isLoading: false,
  empaqueCart: [],
  subTotal: 0,
  total: 0,
  empaqTipoEnvio: 'paquete',
  empaqResume: '',
  useEmpaquetado: false,
  almacenId: ''
};

const slice = createSlice({
  name: 'dagpacketEmpaquetado',
  initialState,
  reducers: {
    // START LOADING
    resetInitialState(state) {
      state.isLoading = false;
      state.empaqueCart = [];
      state.subTotal = 0;
      state.total = 0;
      state.empaqTipoEnvio = 'paquete';
      state.empaqResume = '';
      state.useEmpaquetado = false;
    },

    getAlmacenId(state, action) {
      const id = action.payload;
      state.almacenId = id;
    },

    addEmpaqueCart(state, action) {
      const obj = action.payload;

      if (obj.variant === 'sobre') {
        state.empaqueCart = [obj];
      }
      if (obj.type === 'empaque') {
        const filtered = state.empaqueCart.filter((emp) => emp.type !== 'empaque');
        state.empaqueCart = [...filtered, obj];
      }
      if (obj.type === 'recubrimiento') {
        const filtered = state.empaqueCart.filter((emp) => emp.type !== 'recubrimiento');
        state.empaqueCart = [...filtered, obj];
      }
    },

    removeEmpaque(state, action) {
      const id = action.payload;

      const filtered = state.empaqueCart.filter((item) => item.id !== id);
      state.empaqueCart = filtered;
    },

    calcTotal(state, action) {
      const obj = action.payload;
      // const { selected_price } = obj;
      const cartArr = state.empaqueCart;

      let total = 0;
      let totalCompra = 0;
      let utility = 0;

      // eslint-disable-next-line array-callback-return
      cartArr.map((item) => {
        total += item.selected_price;
        totalCompra += item.price_compra;
        utility += item.selected_price - item.price_compra;
      });

      state.subTotal = total;
      state.total = total;
      state.totalCompra = totalCompra;
      state.utility = utility;
    },

    setEmpaqTipoEnvio(state) {
      const tipoSobre = state.empaqueCart.find((item) => item.variant === 'sobre');
      if (tipoSobre) {
        state.empaqTipoEnvio = 'sobre';
      } else {
        state.empaqTipoEnvio = 'paquete';
      }
    },

    setEmpaqResume(state, action) {
      const data = action.payload;

      state.empaqResume = data;
      state.useEmpaquetado = true;
    }
  }
});

// Reducer
export default slice.reducer;

// Actions
export const {
  addEmpaqueCart,
  removeEmpaque,
  calcTotal,
  setEmpaqTipoEnvio,
  setEmpaqResume,
  getAlmacenId,
  resetInitialState
} = slice.actions;

// ----------------------------------------------------------------------

export function addEmpaqueCartAction(obj) {
  return (dispatch) => {
    dispatch(addEmpaqueCart(obj));
    dispatch(calcTotal(obj));
    dispatch(setEmpaqTipoEnvio());
  };
}

export function removeEmpaqueAction(obj) {
  return (dispatch) => {
    dispatch(removeEmpaque(obj.id));
    dispatch(calcTotal(obj));
    dispatch(setEmpaqTipoEnvio());
  };
}

// ----------------------------------------------------------------------
